var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("CapexItemEditor", {
        attrs: { viewModel: _vm.capexItemEditor },
        on: { "form-submit": _vm.handleCapexItemEditorFormSubmit },
      }),
      _vm._v(" "),
      _vm.isWorkspaceMember
        ? _c("PortfolioNavigation", {
            attrs: {
              workspaceId: _vm.workspaceId,
              projectId: _vm.tchProjectId,
            },
          })
        : _vm.isProjectOwner
        ? _c("Navigation")
        : _vm._e(),
      _vm._v(" "),
      _vm.rm
        ? _c(
            "div",
            {
              staticClass: "container-fluid",
              staticStyle: { "margin-top": "80px", "padding-top": "40px" },
            },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-6" }, [
                  _c(
                    "h1",
                    {
                      staticStyle: {
                        "font-size": "2em",
                        "font-weight": "300",
                        color: "#33475b",
                        margin: "0",
                      },
                    },
                    [_vm._v(_vm._s(_vm.rm.ProjectName))]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6 text-right align-self-end" },
                  [
                    !_vm.isSubmitted
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-success",
                            staticStyle: { padding: "0.7em 2em" },
                            on: { click: _vm.showCapexCreator },
                          },
                          [
                            _vm._v(
                              "\n                    Create\n                "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isSubmitted
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-secondary",
                            staticStyle: {
                              padding: "0.7em 2em",
                              cursor: "default",
                            },
                            attrs: {
                              disabled: "",
                              title: "You cannot edit a submitted plan",
                            },
                          },
                          [
                            _c("i", { staticClass: "fas fa-lock mr-2" }),
                            _vm._v(" Submitted\n                "),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "sanitizedHref",
                            rawName: "v-sanitizedHref",
                            value: `/#/alternative/dashboard/${_vm.rm.WorkspaceId}/${_vm.rm.TchProjectId}/${_vm.rm.ProjectId}`,
                            expression:
                              "`/#/alternative/dashboard/${rm.WorkspaceId}/${rm.TchProjectId}/${rm.ProjectId}`",
                          },
                        ],
                        staticClass: "btn btn-outline-secondary",
                        staticStyle: { padding: "0.7em 2em" },
                      },
                      [
                        _vm._v(
                          "\n                    Meta data\n                "
                        ),
                      ]
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("ProjectNavigation", {
                staticClass: "mt-4 mb-4",
                attrs: {
                  ActivePage: "capex",
                  workspaceId: _vm.workspaceId,
                  tchProjectId: _vm.tchProjectId,
                  projectId: _vm.projectId,
                  planId: _vm.rm.ProjectPlanId,
                },
              }),
              _vm._v(" "),
              _c("table", { staticClass: "table table-bordered table-hover" }, [
                _c("thead", [
                  _c("tr", [
                    _c("th", [_vm._v("Capex")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Account")]),
                    _vm._v(" "),
                    _c("th", [
                      _vm._v("Cost (" + _vm._s(_vm.rm.CurrencyLabel) + ")"),
                    ]),
                    _vm._v(" "),
                    _c("th", [
                      _vm._v(
                        "Salvage value (" + _vm._s(_vm.rm.CurrencyLabel) + ")"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Useful life (years)")]),
                    _vm._v(" "),
                    _c("th", [
                      _vm._v(
                        "Annual expense (" + _vm._s(_vm.rm.CurrencyLabel) + ")"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("th", { staticStyle: { width: "150px" } }),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.rm.CapexItems, function (c) {
                    return _c("tr", [
                      _c("td", [_vm._v(_vm._s(c.Name))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(c.CapexAccountName))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(_vm.fmtNum(c.Cost)))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(_vm.fmtNum(c.SalvageValue)))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(c.UsefulLifeInYears))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(_vm.fmtNum(c.AnnualExpense)))]),
                      _vm._v(" "),
                      _c("td", [
                        !_vm.isSubmitted
                          ? _c("div", { staticClass: "dropdown" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-outline-secondary dropdown-toggle",
                                  attrs: {
                                    type: "button",
                                    "data-toggle": "dropdown",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                Actions\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "dropdown-menu dropdown-menu-right",
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      on: {
                                        click: function ($event) {
                                          return _vm.showCapexEditor(c)
                                        },
                                      },
                                    },
                                    [_vm._v("Edit")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleDeleteProjectCapexItemCommand(
                                            c
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Delete")]
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isSubmitted
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-outline-secondary",
                                staticStyle: { cursor: "default" },
                                attrs: {
                                  disabled: "",
                                  title: "You cannot modify a submitted plan",
                                },
                              },
                              [
                                _c("i", { staticClass: "fas fa-lock mr-2" }),
                                _vm._v(" Submitted\n                        "),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ])
                  }),
                  0
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }